import getWistiaEl from '../helpers/wistia-iframe';

const buttonEls = document.querySelectorAll('[data-js="videosingle-button"]');
for (let i = buttonEls.length - 1; i >= 0; i -= 1) {
	const buttonEl = buttonEls[i];
	buttonEl.addEventListener('click', () => {
		const { wistiaId } = buttonEl.dataset;
		const wistiaEl = getWistiaEl(wistiaId, true);
		const parentEl = buttonEl.parentElement;
		while (parentEl.children.length > 0) {
			parentEl.removeChild(parentEl.children[0]);
		}
		parentEl.appendChild(wistiaEl);
	});
}
